import React, { Fragment } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import EmployeesTable from "./EmployeesTable";

const EmployeesPage = () => (
  <Fragment>
    <Container fluid={true} style={{ paddingTop: "30px" }}>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody style={{ padding: "15px" }}>
              <EmployeesTable />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </Fragment>
);

export default EmployeesPage;
